// Images
import Step1 from '../../../assets/images/Step1.png';
import Step2 from '../../../assets/images/Step2.png';
import Step3 from '../../../assets/images/Step3.png';
import Step4 from '../../../assets/images/Step4.png';
import Step5 from '../../../assets/images/Step5.png';
import Step6 from '../../../assets/images/Step6.png';
import Journey1 from '../../../assets/images/Journey1.webp';
import Journey2 from '../../../assets/images/Journey2.webp';
import Journey3 from '../../../assets/images/Journey3.webp';
import Journey4 from '../../../assets/images/Journey4.webp';
import Journey5 from '../../../assets/images/Journey5.webp';
import Journey6 from '../../../assets/images/Journey6.webp';
import SessionExpect1 from '../../../assets/images/SessionExpect1.webp';
import SessionExpect2 from '../../../assets/images/SessionExpect2.webp';
import SessionExpect3 from '../../../assets/images/SessionExpect3.webp';
import SessionExpect4 from '../../../assets/images/SessionExpect4.webp';
import SessionExpect5 from '../../../assets/images/SessionExpect5.webp';
import PersonalizedSupport1 from '../../../assets/images/PersonalizedSupport1.svg';
import PersonalizedSupport2 from '../../../assets/images/PersonalizedSupport2.svg';
import PersonalizedSupport3 from '../../../assets/images/PersonalizedSupport3.svg';
import PersonalizedSupport4 from '../../../assets/images/PersonalizedSupport4.svg';
import ChooseNirva1 from '../../../assets/images/ChooseNirva1.svg';
import ChooseNirva2 from '../../../assets/images/ChooseNirva2.svg';
import ChooseNirva3 from '../../../assets/images/ChooseNirva3.svg';
import ChooseNirva4 from '../../../assets/images/ChooseNirva4.svg';
import ChooseNirva5 from '../../../assets/images/ChooseNirva5.svg';
import section7Bg from '../../../assets/images/journey-Bg.webp';
import { avatarPlaceholderColors } from '../../../constants/theme';
import JennieWarner from '../../../assets/images/Jennie_Warner.png';
import JasmineJarrett from '../../../assets/images/JasmineJarrett.webp';
import IrisRoseFeraldi from '../../../assets/images/IrisRoseFeraldi.webp';
import AshleaDillard from '../../../assets/images/AshleaDillard.webp';
import MichelleMolnar from '../../../assets/images/MichelleMolnar.webp';
import PaulaJimemez from '../../../assets/images/PaulaJimemez.webp';
import MariahMarshall from '../../../assets/images/MariahMarshall.png';
import AnnMarieMoralesEar from '../../../assets/images/AnnMarieMoralesEar.jpg';
import LaurenWelchner from '../../../assets/images/LaurenWelchner.webp';
import { CONSULTATION_COPY } from '../../../constants/consultation';

export const statisticsNew = [
  {
    number: 1,
    title: 'Overall Evidence\nFor Hypnotherapy',
    subtitle: 'Meta-analysis',
    description: [
      {
        type: 'text',
        content:
          'When hypnosis is added to established approaches (like CBT), studies often show improved outcomes compared to the same approach without hypnosis.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Kirsch, I., Montgomery, G., & Sapirstein, G. (1995). ',
          },
          {
            type: 'italic',
            content:
              'Hypnosis as an adjunct to cognitive-behavioral psychotherapy: A meta-analysis. Journal of Consulting and Clinical Psychology ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/7751482/',
            text: 'PubMed+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Lynn, S. J., et al. (2010). ',
          },
          {
            type: 'italic',
            content: 'Hypnosis and clinical pain. American Psychological Association ',
          },
          {
            type: 'link',
            href: 'https://openlibrary.org/books/OL23622573M/Handbook_of_clinical_hypnosis',
            text: 'Open Library+1',
          },
        ],
      },
    ],
  },
  {
    number: 2,
    title: 'Headaches & Migraines',
    subtitle: 'Systematic review',
    truncateAt: 120,
    description: [
      {
        type: 'text',
        content:
          'Systematic reviews and clinical reviews suggest hypnosis (often alongside relaxation/\nimagery approaches) may reduce short- and long-term headache activity in studied migraine populations.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Hammond, D. C. (2007). ',
          },
          {
            type: 'italic',
            content:
              'Review of the efficacy of clinical hypnosis with headaches and migraines. International Journal of Clinical and Experimental Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/17365074/',
            text: 'PubMed',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Flynn, N. (2018). ',
          },
          {
            type: 'italic',
            content:
              'Systematic Review of the Effectiveness of Hypnosis for the Management of Headache. International Journal of Clinical and Experimental Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/30152733/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
  {
    number: 3,
    title: 'Pain & Comfort',
    subtitle: 'Meta-analysis + Review',
    truncateAt: 125,
    description: [
      {
        type: 'text',
        content:
          'Across studied settings, research reviews and meta-analyses report meaningful reductions in pain ratings for many participants using hypnosis-based approaches (often including self-hypnosis).',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Montgomery, G. H., DuHamel, K. N., & Redd, W. H. (2000). ',
          },
          {
            type: 'italic',
            content:
              'A meta-analysis of hypnotically induced analgesia: How effective is hypnosis? International Journal of Clinical and Experimental Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/10769981/',
            text: 'PubMed+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Elkins, G., Jensen, M. P., & Patterson, D. R. (2007). ',
          },
          {
            type: 'italic',
            content:
              'Hypnotherapy for the management of chronic pain. International Journal of Clinical and Experimental Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/17558718/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
  {
    number: 4,
    title: 'Stress & Anxiety',
    subtitle: 'Meta-analysis',
    truncateAt: 110,
    description: [
      {
        type: 'text',
        content:
          'Meta-analyses report meaningful reductions in anxiety symptoms in studied settings, especially when hypnosis is combined with other supportive approaches.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Hammond, D. C. (2010). ',
          },
          {
            type: 'italic',
            content:
              'Hypnosis in the treatment of anxiety- and stress-related disorders. Expert Review of Neurotherapeutics ',
          },
          {
            type: 'link',
            href: 'https://www.ovid.com/journals/exneu/fulltext/10.1586/ern.09.140~hypnosis-in-the-treatment-of-anxiety--and-stress-related',
            text: 'Ovid',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Valentine, K. E., Milling, L. S., Clark, L. J., & Moriarty, C. L. (2019). ',
          },
          {
            type: 'italic',
            content:
              'The efficacy of hypnosis as a treatment for anxiety: A meta-analysis. International Journal of Clinical and Experimental Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/31251710/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
  {
    number: 5,
    title: 'Allergies & Immune-Related\nResponses',
    subtitle: 'Review + controlled studies',
    truncateAt: 128,
    description: [
      {
        type: 'text',
        content:
          'Clinical reviews and controlled studies suggest hypnosis-based relaxation/imagery may influence stress-related immune markers in studied groups, and may be associated with changes in allergic response measures in some study settings.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Wyler-Harper, J., Bircher, A. J., Langewitz, W., & Kiss, A. (1994). ',
          },
          {
            type: 'italic',
            content: 'Hypnosis and the allergic response. Schweiz Med Wochenschr Suppl ',
          },
          { type: 'link', href: 'https://pubmed.ncbi.nlm.nih.gov/8073242/', text: 'PubMed+2' },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Kiecolt-Glaser, J. K., et al. (2001). ',
          },
          {
            type: 'italic',
            content:
              'Hypnosis as a modulator of cellular immune dysregulation during acute stress. Journal of Consulting and Clinical Psychology ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/11550733/',
            text: 'PubMed+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Gruzelier, J., et al. (2001). ',
          },
          {
            type: 'italic',
            content:
              'Cellular and humoral immunity, mood and exam stress: the influences of self-hypnosis and personality predictors. International Journal of Psychophysiology ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/11451479/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
  {
    number: 6,
    title: 'Pediatric Applications',
    subtitle: 'Methodological review + Clinical reference',
    truncateAt: 109,
    description: [
      {
        type: 'text',
        content:
          'Research reviews suggest hypnosis can support comfort during certain pediatric procedures in studied settings, and pediatric-focused clinical literature outlines applications and best practices for working with children and adolescents.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Accardi, M. C., & Milling, L. S. (2009). ',
          },
          {
            type: 'italic',
            content:
              'The effectiveness of hypnosis for reducing procedure-related pain in children and adolescents: A comprehensive methodological review. Journal of Behavioral Medicine ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/19255840/',
            text: 'PubMed+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Kohen, D. P., & Olness, K. (2011). ',
          },
          {
            type: 'italic',
            content: 'Hypnosis and Hypnotherapy With Children (4th ed.). Routledge ',
          },
          {
            type: 'link',
            href: 'https://openlibrary.org/books/OL25042150M/Hypnosis_and_hypnotherapy_with_children',
            text: 'Open Library+1',
          },
        ],
      },
    ],
  },
  {
    number: 7,
    title: 'Mood Support\n(Depressive Symptoms)',
    subtitle: 'Meta-analysis',
    truncateAt: 109,
    description: [
      {
        type: 'text',
        content:
          'Clinical research (including a meta-analysis and an RCT) suggests hypnosis-integrated approaches can be associated with meaningful improvements in depressive symptoms in studied settings, including evidence that adding hypnosis to CBT methods may improve outcomes versus CBT alone.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Alladin, A., & Alibhai, A. (2007). ',
          },
          {
            type: 'italic',
            content:
              'Cognitive hypnotherapy for depression: an empirical investigation. International Journal of Clinical and Experimental Hypnosis ',
          },
          { type: 'link', href: 'https://pubmed.ncbi.nlm.nih.gov/17365072/', text: 'PubMed+1' },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Shih, M., Yang, Y.-H., & Koo, M. (2009). ',
          },
          {
            type: 'italic',
            content:
              'A meta-analysis of hypnosis in the treatment of depressive symptoms: A brief communication. International Journal of Clinical and Experimental Hypnosis ',
          },
          { type: 'link', href: 'https://pubmed.ncbi.nlm.nih.gov/20183000/', text: 'PubMed+1' },
        ],
      },
    ],
  },
  {
    number: 8,
    title: 'Breathing Comfort\n(Asthma Research)',
    subtitle: 'Review + Randomized controlled trial',
    truncateAt: 133,
    description: [
      {
        type: 'text',
        content:
          'A clinical review summarizes that research to date shows promising findings, while also emphasizing that larger, well-designed trials are still needed. One randomized controlled trial reported improvements in bronchial hyper-responsiveness and symptom recordings in a subgroup of participants with higher hypnotic susceptibility.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Hackman, R. M., Stern, J. S., & Gershwin, M. E. (2000). ',
          },
          {
            type: 'italic',
            content: 'Hypnosis and asthma: a critical review. J Asthma ',
          },
          { type: 'link', href: 'https://pubmed.ncbi.nlm.nih.gov/10724294/', text: 'PubMed' },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content:
              'Ewer, T. C., & Stewart, D. E. (1986). Improvement in bronchial hyper-responsiveness in patients with moderate asthma after treatment with a hypnotic technique: a randomised controlled trial. Br Med J (Clin Res Ed) ',
          },
          {
            type: 'italic',
            content:
              'Improvement in bronchial hyper-responsiveness in patients with moderate asthma after treatment with a hypnotic technique: a randomised controlled trial. Br Med J (Clin Res Ed) ',
          },
          {
            type: 'link',
            href: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC1341848/',
            text: 'PMC',
          },
        ],
      },
    ],
  },
  {
    number: 9,
    title: 'Skin Comfort\n(Eczema, Psoriasis)',
    subtitle: 'Review + clinical studies',
    truncateAt: 128,
    description: [
      {
        type: 'text',
        content:
          'Dermatology literature reviews describe hypnosis as a supportive approach that may help with itch–scratch cycles, stress-related flare patterns, and symptom comfort in studied groups. Clinical studies in atopic dermatitis and psoriasis report improvements in some participants (often influenced by hypnotic responsiveness and study design).',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Shenefelt, P. D. (2000). ',
          },
          {
            type: 'italic',
            content: 'Hypnosis in Dermatology. Archives of Dermatology ',
          },
          {
            type: 'link',
            href: 'https://jamanetwork.com/journals/jamadermatology/article-abstract/190040',
            text: 'JAMA Network+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Stewart, A. C., & Thomas, S. E. (1995). ',
          },
          {
            type: 'italic',
            content:
              'Hypnotherapy as a treatment for atopic dermatitis in adults and children. British Journal of Dermatology ',
          },
          {
            type: 'link',
            href: 'https://academic.oup.com/bjd/article-abstract/132/5/778/6681490',
            text: 'OUP Academic+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Tausk, F., & Whitmore, S. E. (1999). ',
          },
          {
            type: 'italic',
            content:
              'A pilot study of hypnosis in the treatment of patients with psoriasis. Psychotherapy and Psychosomatics ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/10396014/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
  {
    number: 10,
    title: 'Gut–Brain Comfort\n(IBS)',
    subtitle: 'Randomized controlled trial + review',
    truncateAt: 126,
    description: [
      {
        type: 'text',
        content:
          'A foundational randomized controlled trial reported significant improvement in IBS features in a severe, refractory IBS sample compared with control conditions. Later reviews summarize the broader evidence base for gut-directed hypnosis in IBS and discuss where it appears most helpful.',
      },
    ],
    references: [
      {
        text: [
          {
            type: 'text',
            content: 'Whorwell, P. J., Prior, A., & Faragher, E. B. (1984). ',
          },
          {
            type: 'italic',
            content:
              'Controlled trial of hypnotherapy in the treatment of severe refractory irritable-bowel syndrome. The Lancet Manchester Research ',
          },
          {
            type: 'link',
            href: 'https://research.manchester.ac.uk/en/publications/controlled-trial-of-hypnotherapy-in-the-treatment-of-severe-refra/',
            text: 'PubMed+1',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Häuser, W. (2024). ',
          },
          {
            type: 'italic',
            content:
              'Gut-directed hypnosis and hypnotherapy for irritable bowel syndrome: a mini-review. Frontiers in Psychology ',
          },
          {
            type: 'link',
            href: 'https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2024.1389911/full',
            text: 'Frontiers',
          },
        ],
      },
      {
        text: [
          {
            type: 'text',
            content: 'Palsson, O. S. (2015). ',
          },
          {
            type: 'italic',
            content:
              'Hypnosis treatment of gastrointestinal disorders: A comprehensive review of the empirical evidence. American Journal of Clinical Hypnosis ',
          },
          {
            type: 'link',
            href: 'https://pubmed.ncbi.nlm.nih.gov/8823562/',
            text: 'PubMed+1',
          },
        ],
      },
    ],
  },
];

export const hypnotherapyfaq = [
  {
    number: 1,
    title: 'Clarify Your Goals',
    description:
      'We begin with a brief conversation to understand what you want to change or improve.',
  },
  {
    number: 2,
    title: 'Personalized Approach',
    description:
      'Your practitioner designs a session plan that fits your pace, preferences, and values.',
  },
  {
    number: 3,
    title: 'Guided Hypnosis',
    description:
      "You're invited into a calm, focused state—fully aware, relaxed, and in control the entire time.",
  },
  {
    number: 4,
    title: 'Integration',
    description: 'You’ll receive simple practices to reinforce new patterns between sessions.',
  },
];

export const practitionerfaq = [
  {
    number: 1,
    title: 'Clear and upfront — no hidden fees, no surprises.',
    description: '',
  },
  {
    number: 2,
    title: 'Flexible formats — sessions are 60 to 120 minutes. Each clock hour includes 50 minutes of dedicated session time within a 60-minute scheduling block.',
    description: '',
  },
  {
    number: 3,
    title:
      'Competitive rates — priced to reflect the professionalism of our certified practitioners while remaining affordable compared to many traditional services.',
    description: '',
  },
  {
    number: 4,
    title:
      'Membership & packages — options that make ongoing sessions easier and more cost-effective.',
    description: '',
  },
  {
    number: 5,
    title:
      'Free first step — every new client begins with a complimentary consultation to explore fit and ask questions.',
    description: '',
  },
];

export const steps = [
  {
    number: 1,
    title: 'You Arrive',
    description:
      "You've found your way here, whether by searching, a recommendation, or pure curiosity.",
    numberImage: Step1,
    subtitle: 'Your first step is simple:',
    checklist: [
      'Request a free 30-minute consultation through our secure SimplePractice booking flow.',
      'Complete a short prescreener so we can better understand your goals, location, and practitioner preference.',
    ],
    image: Journey1,
  },
  {
    number: 2,
    title: `You Request Your ${CONSULTATION_COPY.label}`,
    description:
      'When you request a consultation, you’ll share a few brief details through SimplePractice, including your name, contact information, practitioner preference, and what kind of support you’re looking for.',
    numberImage: Step2,
    subtitle: '',
    checklist: [
      'Nirva reviews the request before confirming.',
      'If appropriate, your consultation is scheduled through SimplePractice Telehealth.',
    ],
    image: Journey2,
  },
  {
    number: 3,
    title: 'You Connect With a Practitioner During Your Free Consultation',
    description: '',
    subtitle: '',
    numberImage: Step3,
    checklist: [
      'Your practitioner listens to what brings you here.',
      'Together, you explore whether hypnotherapy feels like an appropriate fit.',
      'If you choose to move forward, your next steps are handled securely through SimplePractice.',
    ],
    image: Journey3,
  },
  {
    number: 4,
    title: 'You Complete Client Portal Forms',
    description:
      'If you choose to move forward after your consultation, you’ll complete required forms securely through the SimplePractice Client Portal.',
    subtitle: '',
    numberImage: Step4,
    checklist: [
      'Review Nirva’s client agreements and privacy documents.',
      'Complete any required forms before your first paid session.',
      'Your practitioner may provide additional intake questions if helpful.',
    ],
    image: Journey4,
  },
  {
    number: 5,
    title: "You Schedule Your First Session When You're Ready",
    description: '',
    subtitle: '',
    numberImage: Step5,
    checklist: [
      'Your practitioner or Nirva admin will help you schedule your ongoing session through SimplePractice.',
      'You’ll receive confirmation and access details through SimplePractice.',
      'Sessions are held through SimplePractice Telehealth unless otherwise approved.',
    ],
    image: Journey5,
  },
  {
    number: 6,
    title: 'The Experience Is in Your Hands, With Support Along the Way',
    description: '',
    subtitle: '',
    numberImage: Step6,
    checklist: [
      'Personal: a real practitioner welcomes you.',
      'Professional: secure, confidential, and organized through SimplePractice.',
      'Peaceful: your journey unfolds at your own pace.',
    ],
    image: Journey6,
  },
];

export const expectsteps = [
  {
    number: 1,
    title: 'A Warm Welcome',
    description:
      'Your practitioner begins with a short conversation to check in, answer your questions, and set a clear intention for the session. This ensures you feel grounded, seen, and understood before any hypnosis begins.',
    subtitle: '',
    checklist: [],
    image: SessionExpect1,
  },
  {
    number: 2,
    title: 'Guided Relaxation',
    description:
      "You'll be gently guided into a state of focused relaxation. This isn't sleep—rather, it's a natural shift where the mind quiets, and your awareness becomes calm and centered. You remain in control the entire time.",
    subtitle: '',
    checklist: [],
    image: SessionExpect2,
  },
  {
    number: 3,
    title: 'Personalized Hypnosis',
    description:
      'Based on your goals, the practitioner uses carefully chosen words, imagery, and processes to help you access the subconscious mind. This allows you to explore new perspectives, release limiting patterns, and activate beneficial change from within.',
    subtitle: '',
    checklist: [],
    image: SessionExpect3,
  },
  {
    number: 4,
    title: 'Supportive Closure',
    description:
      'At the end, your practitioner brings you back into full waking awareness—often with a sense of clarity, lightness, and calm. Many clients describe this as a refreshing reset for the mind.',
    subtitle: '',
    checklist: [],
    image: SessionExpect4,
  },
  {
    number: 5,
    title: 'Integration & Next Steps',
    description:
      "You 'll have time to reflect on your experience, ask questions, and (if desired) receive simple practices to continue reinforcing your goals between sessions. This makes the process practical and empowering, extending the benefits into your daily life.",
    subtitle: '',
    checklist: [],
    image: SessionExpect5,
  },
];

export const benefits = [
  {
    icon: PersonalizedSupport1,
    title: 'Shifting Unwanted\nPatterns And Habits',
  },
  {
    icon: PersonalizedSupport2,
    title: 'Creating Balance Around Anxious Or Heavy Emotions',
  },
  {
    icon: PersonalizedSupport3,
    title: 'Finding Ease Through\nStress Reduction\nPractices',
  },
  {
    icon: PersonalizedSupport4,
    title: 'Nurturing Healthier\nConnections And\nRelationships',
  },
];

export const features = [
  {
    icon: ChooseNirva1,
    title: 'Certified\nProfessionals',
  },
  {
    icon: ChooseNirva2,
    title: 'Private &\nSecure Platform',
  },
  {
    icon: ChooseNirva3,
    title: 'Personalized\nCare',
  },
  {
    icon: ChooseNirva4,
    title: 'Seamless\nOnline Sessions',
  },
  {
    icon: ChooseNirva5,
    title: 'Transformational,\nLasting Change',
  },
];

export const testimonialsslider = [
  // {
  //   id: 1,
  //   text: `"Susan is amazing in her
  //   insights an conversational
  //   approach."`,
  //   boldText: `I am so glad and blessed
  //   to have found her and started
  //   healing with her guidance.`,
  //   name: 'Susan Hargett',
  // credentials: 'Michele Johnson (MA, LPC-S)',
  //   avatar: Susan,
  //   backgroundColor: avatarPlaceholderColors.yellow,
  // },
  // {
  //   id: 2,
  //   text: `"Working with my practitioner
  //   has been life-changing."`,
  //   boldText: `I never thought I could overcome
  //   my anxiety, but here I am,
  //   living my best life.`,
  //   name: 'John Davis',
  //   credentials: 'Sarah Thompson (CHT, IAIH)',
  //   avatar: '../../assets/images/testimonial2.jpg',
  //   backgroundColor: avatarPlaceholderColors.skyBlue,
  // },
  // {
  //   id: 3,
  //   text: `"The hypnotherapy sessions
  //   exceeded all my
  //   expectations."`,
  //   boldText: `I feel more confident, focused,
  //   and in control of my life than
  //   ever before.`,
  //   name: 'Emily Chen',
  //   credentials: 'Dr. Michael Roberts (PhD, CHT)',
  //   avatar: '../../assets/images/testimonial3.jpg',
  //   backgroundColor: avatarPlaceholderColors.lilac,
  // },
  // {
  //   id: 4,
  //   text: `"I was skeptical at first, but
  //   the results speak for
  //   themselves."`,
  //   boldText: `My stress levels have decreased
  //   dramatically and I sleep better
  //   than I have in years.`,
  //   name: 'Robert Martinez',
  //   credentials: 'Jennifer Lee (MA, CHT)',
  //   avatar: '../../assets/images/testimonial4.jpg',
  //   backgroundColor: avatarPlaceholderColors.rose,
  // },
  {
    id: 10,
    text: `"From our video introduction, I knew Jennie would help me kick my unwanted habits."`,
    boldText: `She gave me the tools to conquer those and a sense of empowerment. She blends empathy with straightforward instructions, tailored to my needs. That's what separates her from others I interviewed: her creativity in mining the root cause of habits clicked. I didn't change overnight, but I've come to believe that practitioners who claim overnight change aren't honest. Thank you, Jennie!`,
    name: 'Gisele L.',
    practitionerName: 'Jennie Warner',
    avatar: JennieWarner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 11,
    text: '"Jennie helped me through anxiety after a fender bender."',
    boldText: `She is like a Sherpa... she guided me up what felt like a mountain, and helped me with my baggage until I offloaded it! Amazing! She is kind, caring, and strong—and very smart! I treasure her expertise.`,
    name: 'Barb M.',
    practitionerName: 'Jennie Warner',
    avatar: JennieWarner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 12,
    text: '"I had an EFT Hypnotherapy session with Jennie. I felt very safe and comfortable with Jennie."',
    boldText: `Her knowledge, guidance, and confidence were so supportive in my healing. It was a transformative experience, and I noticed immediate, continued results in my growth process. It is still amazing to me to see how old traumas impact our lives today, and how possible it is to heal and transform our lives for the better. Thank you, Jennie.`,

    name: 'Deb D.',
    practitionerName: 'Jennie Warner',
    avatar: JennieWarner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 13,
    text: '"Jennie Warner is a superb hypnotherapist."',
    boldText: `I have been working with Jennie on a number of different issues, and she helped me tremendously. Jennie is also great with children. After just a couple of sessions with my 10-year-old, I've seen big improvements in how my daughter deals with her problems. Not only is Jennie a great professional with amazing skills and tools, but she is also caring, kind, and trustworthy. I highly recommend Jennie!`,
    name: 'Diana D.',
    practitionerName: 'Jennie Warner',
    avatar: JennieWarner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
  {
    id: 14,
    text: '"Working with Jennie was an absolute joy!"',
    boldText: `I learned about hypnosis and EFT Tapping in a very comfortable way, and I now have reduced my fears and anxieties significantly! Thank you, Jennie, for opening my mind to new options I didn't even know existed!`,
    name: 'Paul W.',
    practitionerName: 'Jennie Warner',
    avatar: JennieWarner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 15,
    text: `"Working with Jasmine has been a deeply transformative and grounding experience."`,
    boldText: `Her hypnotherapy sessions are incredibly relaxing and intuitive, gently guiding me inward and reminding me of who I truly am. Her voice is beyond calming, and her presence creates a space that feels safe, supportive, and deeply nurturing. Each session leaves me feeling clearer, lighter, and more aligned with myself. I'm grateful for the journey we've shared and will continue exploring new topics with her, eager to see how she helps me discover even deeper layers of self-awareness. She makes this inner work feel empowering and safe, and there is truly no one else I would rather choose to walk this path with.`,
    name: 'Keiko S.',
    practitionerName: 'Jasmine Jarrett',
    avatar: JasmineJarrett,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 16,
    text: `"I reached out to Jasmine for hypnotherapy to help with my phobia of flying, as well as exploring past life regression."`,
    boldText: `My experience with Jasmine was nothing short of extraordinary. I'm now looking forward to my upcoming travel now that I'm able to see it in a new light. She took her time, which led me on a beautiful, healing journey and allowed plenty of time to absorb the experience. Jasmine's sincerity and the safe environment she fostered made the entire process incredibly comforting. I would highly recommend working with Jasmine. She is exceptionally skilled and talented in hypnotherapy. Beyond her professional abilities, Jasmine is a gentle soul with a charismatic and spiritually in-touch demeanor that adds a unique and wonderful element to her practice.`,
    name: 'Barbara R.',
    practitionerName: 'Jasmine Jarrett',
    avatar: JasmineJarrett,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 17,
    text: `"Working with Jasmine, I first learned how to articulate a variety of behavioral and quality-of-life objectives."`,
    boldText: `I feel not only understood, but reacquainted with my own self-concept through her deliberate conversational guidance and encouragement to dig deep on the internal changes I most require. Reflecting on a session in hindsight heightens its original insights, making hypnotic playbacks more valuable with each relisten. Instructionally and vocally, Jasmine primed me to internalize an eagerness to progress in my obtainment of the changes we discussed. She evolves my goals into vessels that are moving me forward in measurable ways. Movement that is happening both consciously and unconsciously.`,
    name: 'Jacob M.',
    practitionerName: 'Jasmine Jarrett',
    avatar: JasmineJarrett,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 18,
    text: `"Jasmine is fantastic! I had such an incredible experience working with her."`,
    boldText: `She did her best in making me feel comfortable and safe, and she took her time with listening to my emotions and needs. I was hesitant at first going into it, especially because I had never done hypnotherapy before. But she made it worth it! All the anxieties and questions I had were treated with warmth and kindness, and she's very knowledgeable in what she does. I'd highly recommend booking a session with her, I truly do feel like she helped with my healing process.`,
    name: 'Annelie C.',
    practitionerName: 'Jasmine Jarrett',
    avatar: JasmineJarrett,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 19,
    text: `"I had a truly profound past life regression session with Jasmine."`,
    boldText: `From the moment the session began, I felt completely safe, grounded, and guided with care and professionalism. The experience itself was deeply vivid and insightful. What stood out most was how gently and respectfully Jasmine facilitated the journey, allowing everything to unfold naturally while holding a calm, supportive space. The integration afterward was just as powerful, helping me make sense of what surfaced and release what no longer served me. I left the session feeling lighter, more aligned, and deeply at peace. I would highly recommend this experience to anyone curious about past life work or seeking deep inner healing.`,
    name: 'Anne J.',
    practitionerName: 'Jasmine Jarrett',
    avatar: JasmineJarrett,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
  {
    id: 20,
    text: `"Iris was very patient and kind in our session. She asked the right questions and was a great listener."`,
    boldText: `The hypnosis session itself had a very profound effect on me and helped me better understand myself. I highly recommend Iris to anyone that is looking to hypnotherapy for improvement in their lives. Thank you for your professionalism and your support Iris.`,
    name: 'Josh R.',
    practitionerName: 'Iris Rose Feraldi',
    avatar: IrisRoseFeraldi,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 21,
    text: `"This was by far a life-altering experience."`,
    boldText: `I went in having no idea what was going to be happening or how this was going to work. But there were things buried in my mind that I had no idea about and were able to move forward with my life and I feel like this was the pivotal moment that helped me start that transition. If you're on the fence about it, that means you should go. It will be worth it.`,
    name: 'Hamilton C.',
    practitionerName: 'Iris Rose Feraldi',
    avatar: IrisRoseFeraldi,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 22,
    text: `"I highly recommend Iris and her therapy, I had an excellent experience with her."`,
    boldText: `I went in with a terrible vape habit and walked out ready to kick it for good. Iris does an excellent job of finding the root source of the problem and the best way to solve it. Her techniques are very effective and lasting. Thanks Iris! I really appreciate you.`,
    name: 'Wesley H.',
    practitionerName: 'Iris Rose Feraldi',
    avatar: IrisRoseFeraldi,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 23,
    text: `"Highly recommend Iris if you are looking for a professional hypnotherapist in a safe and relaxing atmosphere."`,
    boldText: `Iris is an amazing listener who puts alot of effort into personalizing our sessions. Everything I needed to know about hypnotherapy was thoroughly explained and I felt very comfortable with Iris. My results have been truly life changing. I'm so thankful to you Iris!`,
    name: 'Jenifer B.',
    practitionerName: 'Iris Rose Feraldi',
    avatar: IrisRoseFeraldi,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 24,
    text: `"Just got a Past Life Regression Session with Iris and she is absolutely amazing."`,
    boldText: `Such a caring and beautiful session that released a lot of stored trauma and blocks that needed to be released. I cannot wait for my next session. Iris is caring and compassionate and pays attention to every detail. Thank you so much Iris for a life changing session 🙏`,
    name: 'Ashley L.',
    practitionerName: 'Iris Rose Feraldi',
    avatar: IrisRoseFeraldi,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 25,
    text: `"I was a skeptic about hypnosis, but I learned it's not what you think."`,
    boldText: `It was such a positive experience, thanks to the talents and skills of Ashlea. If you want to try a technique that works for so many problems, please give her a call. She is sweet and kind along with being very talented and passionate about her work.`,
    name: 'B.D.',
    practitionerName: 'Ashlea Dillard',
    avatar: AshleaDillard,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 26,
    text: `"Ashlea has a rare gift for making you feel understood and supported."`,
    boldText: `Her compassion, patience, and guidance have helped me navigate difficult moments with clarity and confidence especially after the sudden loss of my father.`,
    name: 'W.M.',
    practitionerName: 'Ashlea Dillard',
    avatar: AshleaDillard,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 27,
    text: `"I cannot recommend Ashlea enough."`,
    boldText: `From the very beginning, I felt seen, heard, respected, and supported in a way I hadn't experienced before. Ashlea has helped me navigate one of the most difficult periods of my life, including my divorce and my struggle with alcohol use disorder (just to name a few 🤭). Her approach is compassionate but honest, supportive, yet challenging in the best way. I never felt judged - only encouraged, grounded, and empowered to do the hard work. Because of her guidance, I've gained healthier coping tools, clarity, and a sense of stability I didn't think was possible. If you're looking for a therapist who understands your world and genuinely cares about your healing, Ashlea is the person to see.`,
    name: 'H.G.',
    practitionerName: 'Ashlea Dillard',
    avatar: AshleaDillard,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 28,
    text: `"Ashlea is an incredible person."`,
    boldText: `She's helped me more than I can put into words and has a real talent for understanding people and guiding them forward. I always feel heard, supported, and challenged in a healthy way. I'm genuinely grateful for the impact she's had on my life and highly recommend her.`,
    name: 'B.S.',
    practitionerName: 'Ashlea Dillard',
    avatar: AshleaDillard,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 29,
    text: `"Ashlea is the best!"`,
    boldText: `She created a safe space for me to go within and unpack the emotional stuff that was holding me back from my true self. One of the things I am grateful for this year is that "I feel like I am back!" Back to a more vibrant me! Thank you so much!`,
    name: 'J.T.',
    practitionerName: 'Ashlea Dillard',
    avatar: AshleaDillard,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
  {
    id: 30,
    text: `"Holy Magic!"`,
    boldText: `Wow! My dear, beautiful, wisdom filled friend Michelle Molnar is now offering hypnotherapy and it is...chef's kiss!

If you've ever been curious about this healing modality before, look no further! I went into my time not knowing what to expect and was met with the most calming, nurturing, open-hearted, graceful energy that made all of my being feel held, safe, supported, and guided back to wholeness. I left feeling like I had completed years of work and lifted some supreme stickiness from my mind in just one session ~ I was floating on clouds and remained there for days (in the best way!). My productivity after this reset has been truly eye opening. Michelle is not only a master at her craft, but also a true master of the heart space.

Her energy, voice, and love are healing in and of itself; combine these with her deep wisdom and knowledge of the techniques of hypnotherapy and voila! A true diamond of a healer. I could not more highly recommend a session with Michelle! So, wherever you are...run, don't walk!

Thank you Michelle for your masterful magic!!!`,
    name: 'Arielle M.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 31,
    text: `"I am super grateful for the sessions I've had with Michelle."`,
    boldText: `They were more impactful than many therapy sessions. She makes it really personal and makes you feel at home. I felt very safe to open up to her and found these sessions to be incredible.

I faced issues with using my voice. This helped rebuild my confidence. I worked through limiting beliefs and fears, which helped me navigate life differently, leading to changes in my business, relationship, and self worth. My experience working with Michelle introduced me to parts therapy and creating a mantra I use daily now.

If you're on the fence or worried, you have nothing to lose working with Michelle except your limiting beliefs and what's stopping you from feeling free and limitless!

Jump in with both feet and give it a try and I'm sure you'll be grateful you did.`,
    name: 'Johan D.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 32,
    text: `"During my session with Michelle, I felt calm, serene, safe, secure."`,
    boldText: `The biggest thing that came out of it was I felt like the background chatter, the obtrusive thoughts in my mind, were gone. It was my first experience with hypnosis and I was surprised that I went into hypnosis so quickly and deeply…entering into deep relaxation. It was a wonderful experience and I would recommend a session(s) with Michelle.`,
    name: 'Jen G.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 33,
    text: `"Michelle is a very professional and efficient hypnotherapist."`,
    boldText: `I had three hypnotherapy sessions with Michelle. She did a very professional job addressing issues I have been struggling with in a very efficient manner.

Her presence is very loving and supportive, which helped me to feel guided and safe in opening up to her. She really heard me, deeply connected to my specific needs and seemed to intuitively know what techniques would be most beneficial to me. I felt that I benefitted a lot from the sessions and left feeling much better at the end of each session. I highly recommend Michelle.`,
    name: 'Liliana A.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 34,
    text: `"The work I did with Michelle not only helped me to reach my goals but has allowed me to recognize and let goof unhealthy patterns that were holding me back."`,
    boldText: `Her deep insight and compassionate nature make her a joy to work with. It is an empowering process to experience. I look forward to Michelle's assistance in the future.`,
    name: 'Sherri G.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 35,
    text: `"Working with Michelle Molnar was a truly transformative experience."`,
    boldText: `Her professional and compassionate approach made me feel comfortable, and the tailored techniques she used helped me address my specific issue. I'm grateful for the positive changes I've experienced and highly recommend her to anyone looking for effective, personalized hypnotherapy.`,
    name: 'Lavina S.',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
  {
    id: 36,
    text: `"My sessions with Paula were truly a turning point in my life."`,
    boldText: `They helped me find calm during a time when I deeply needed it, especially throughout my journey into motherhood. With her guidance, I was able to understand what I was going through and bring clarity to my thoughts.

Today, I feel calmer, more present, and much more connected with myself. I'm deeply grateful for her support and for the positive impact she had on my life.`,
    name: 'Liliana R.',
    practitionerName: 'Paula Jimemez',
    avatar: PaulaJimemez,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 37,
    text: `"A Surprisingly Helpful Experience"`,
    boldText: `I decided to try hypnosis to help with my depression and long-standing procrastination, and I'm really glad I gave it a chance. I wasn't sure what to expect at first, but the sessions turned out to be calming, grounding, and surprisingly motivating.

What helped me most was how hypnosis created a sense of mental "space" - almost like hitting a reset button. I felt more present, less overwhelmed, and more able to break tasks into small steps instead of shutting down. Over time, I noticed I was approaching my days with a little more confidence and clarity.

It didn't magically fix everything overnight, but it became a supportive tool in my overall routine. I felt more in tune with my own thoughts, and that alone made it easier to stay consistent and organized.

If you're curious and open to trying new approaches, hypnosis can be a gentle, encouraging way to work on emotional balance and productivity. My experience was genuinely positive, and I'm grateful I tried it and highly recommend working with Paula. I held high trust and comfort with her. I'm extremely grateful!`,
    name: 'Elena T.',
    practitionerName: 'Paula Jimemez',
    avatar: PaulaJimemez,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 38,
    text: `"One of the most revealing experiences of my life!"`,
    boldText: `I never fully understood hypnotherapy until I met Paula. I always knew I had blockages which disrupted my daily life but didn't know why. Each session with Paula revealed things I never even realized affected me so deeply through my behavior and habits. Now I can acknowledge them, adjust my mindset and truly be the woman I want to be. It's really an indescribable feeling of joy and I'd recommend to anyone who wants more out of life.`,
    name: 'Adana P.',
    practitionerName: 'Paula Jimemez',
    avatar: PaulaJimemez,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 39,
    text: `"Paula achieved what no doctor or therapy had been able to."`,
    boldText: `she completely eliminated a physical pain that was preventing me from living normally. In another session, we worked on something that felt impossible: my relationship with order. Since then, I've become more organized in my life, my home, and even my thoughts. I truly feel there was a before and after working with her through hypnosis. She is also a genuinely kind person, professional and fully dedicated to her clients, which created a level of trust that allowed me to open up safely. I recommend her 110%. Thank you, Paula-I will always be grateful.`,
    name: 'Olimpia R.',
    practitionerName: 'Paula Jimemez',
    avatar: PaulaJimemez,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 40,
    text: `"I'm a professional poker player from Brooklyn NY, and for years I've repeated the same programming of acting out of alignment with my financial goals and highest versions of myself when met with an excess of finances. I've tried various methods of healing including therapy, breath work, meditation, mentorship and chakra work. All of those tools were impactful, but nothing was as impactful as my sessions with Mariah."`,
    boldText: ``,
    name: 'Jesse M.',
    practitionerName: 'Mariah Marshall',
    avatar: MariahMarshall,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 41,
    text: `"This was my first time engaging with hypnotherapy and I feel so fortunate to have been guided through this process by someone as kind and supportive as Mariah. Her natural ability to connect and her desire to facilitate and support my personal journey is what made this an extremely special experience. Her passion, patience and desire to help was evident throughout all of the sessions and something I will always be grateful for. I would highly recommend Mariah if you are considering embarking on your own personal journey through the practice of hypnotherapy and wish you the best of luck as you do."`,
    boldText: ``,
    name: 'Aoife M.',
    practitionerName: 'Mariah Marshall',
    avatar: MariahMarshall,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 42,
    text: `"I was diagnosed with MS in 2018 and spent years in a fog of depression and despair, fixated on past losses and a bleak future. Though initially nervous, Mariah's prompt email responses and our first session were magical. Her creativity made the experience vivid and transformative, allowing me to see through the fog. Each session made life more bearable. Tracking my mood due to MS, I saw clear improvements with every session. Over a few months, my perspective shifted from mourning the past to focusing on the future. Mariah's support helped me manage MS challenges, stay motivated, eat healthier, exercise consistently, and achieve my best physical shape. Mariah is like a guardian angel, transforming my life with her kind, empathetic, and patient approach. If you're struggling and considering hypnotherapy, Mariah's life-changing guidance and poetic words can make a profound difference. Taking a leap of faith with her was the best decision—I feel closer to my true self than ever."`,
    boldText: ``,
    name: 'Toby B.',
    practitionerName: 'Mariah Marshall',
    avatar: MariahMarshall,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.mint,
  },
  {
    id: 43,
    text: `"I had a hypnotherapy session with Ann Marie and I was very impressed by her love and dedication for this work."`,
    boldText: `Although I worked on personal development for some years, it was my first time experiencing hypnotherapy and Ann Marie, which is an amazing gifted person, created a beautiful and loving space during this session that allowed me to trust and go deep in my being so I can release what my subconscious keep rolling without me even realizing. It is the fastest way through you can experience healing and release and the effects are instantly visible. I highly recommend! Much love`,
    name: 'Raluca A.',
    practitionerName: 'Ann Marie Morales-Ear',
    avatar: AnnMarieMoralesEar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.coral,
  },
  {
    id: 44,
    text: `"I had a hypnosis session with Ann Marie to address negative patterns in my behaviour that were affecting my relationships."`,
    boldText: `During the session, she gently guided me to a deeply traumatic moment that, even after 10 years, was still shaping my life. With her intuitive support, I was able to safely release intense emotions that had been repressed for a decade. Together, we transformed an overprotective energetic aspect of myself, allowing that energy to flow more freely and lovingly. I'm infinitely grateful for Ann Marie's spot-on intuitive guidance, and her compassionate and loving way to connect with my most tender aspects. I feel as though an invisible yet incredibly heavy burden has finally been lifted.`,
    name: 'Leila Z.',
    practitionerName: 'Ann Marie Morales-Ear',
    avatar: AnnMarieMoralesEar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lavender,
  },
  {
    id: 45,
    text: `"Thank you for the amazing past life experience."`,
    boldText: `Your expertise, your calming melodic voice, and prompts immediately created for me a comfortable and safe environment as we journeyed into the session. I was able to discover more than I expected. I have had many past life sessions over the years and, as a regressionist myself, I can wholeheartedly recommend your services. Thank you so much for the experience and your service to help others. Without a doubt, a session with you can help heal old wounds, break unhelpful patterns, and make positive changes in a person's life.`,
    name: 'Marsha M.',
    practitionerName: 'Barbara Robinson',
    avatar: 'https://iphcstorage.s3.us-east-1.amazonaws.com/1775580058499-BarbaraRobinson.jpg',
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.yellow,
  },
  {
    id: 46,
    text: `"I had an AMAZING experience with Barbara."`,
    boldText: `The hypnotherapy session was extremely relaxing. The way Barbara described what she wanted me to imagine was so vivid that I felt like I was actually in the place she described. I booked the session to get help stopping smoking. That was 3 weeks ago, and I haven't had a cigarette since my session. I've hardly had any strong temptations. Barbara's gentleness and kindness make it evident that she is walking you through your journey with love and support. I could not be happier. I would recommend her with the highest recommendation possible. I am so thankful that I am now and forever a non-smoker. Thank you, thank you, thank you, Barbara!`,
    name: 'Pam J.',
    practitionerName: 'Barbara Robinson',
    avatar: 'https://iphcstorage.s3.us-east-1.amazonaws.com/1775580058499-BarbaraRobinson.jpg',
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.skyBlue,
  },
  {
    id: 47,
    text: `"Barbara saved my life."`,
    boldText: `After a lifelong struggle with the poison sugar, she in one session cured me of this addiction. The 10 pounds lost are minor compared to the relief of no longer feeling anxious and guilty from eating so many desserts. Thank you, Barbara, for all your help.`,
    name: 'Ingrid D.',
    practitionerName: 'Barbara Robinson',
    avatar: 'https://iphcstorage.s3.us-east-1.amazonaws.com/1775580058499-BarbaraRobinson.jpg',
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 48,
    text: `"The experience was more than I expected."`,
    boldText: `She made me feel relaxed, which allowed me to get the most from the session. It has been over a month since I met with Barbara to help me with sleep issues. I use the methods she recommended, and my ability to fall asleep has improved greatly.`,
    name: 'Penny F.',
    practitionerName: 'Barbara Robinson',
    avatar: 'https://iphcstorage.s3.us-east-1.amazonaws.com/1775580058499-BarbaraRobinson.jpg',
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 49,
    text: `"Working with Barbara has been so empowering and transformative."`,
    boldText: `I love her energy. She is very empathetic and intuitive and held space for me to clear some emotional blockages. We worked together to overcome my smoking habit, and she gave me several tools to encourage my success at home. I look forward to working with her again for other issues I want to overcome. Thank you!`,
    name: 'Jasmine J.',
    practitionerName: 'Barbara Robinson',
    avatar: 'https://iphcstorage.s3.us-east-1.amazonaws.com/1775580058499-BarbaraRobinson.jpg',
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
  {
    id: 50,
    text: `"Hello Michelle! I hope spring finds you doing well! I just wanted to thank you again for your help. I wanted to share with you that as of today, I hit my "ideal weight"!!!!!! Officially going into maintenance mode!!! I truly never thought that I would get here. Thank you so much for your help (I still do my hypnosis once a week) at this point I think I could repeat it verbatim 😆😆😆 you truly gave me back confidence that I NEVER thought I would experience again in my life. 🩵 just wanted to let you know. Have a good night!"`,
    boldText: ``,
    name: 'Stacey T., LCSW, CCTP – II',
    practitionerName: 'Michelle Molnar',
    avatar: MichelleMolnar,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.coral,
  },
  {
    id: 51,
    text: `"It is with great honour and gratitude that I share my experience with Lauren and her hypnotherapy practice."`,
    boldText: `Through working with Lauren, I was able to travel to deep places of my subconscious and communicate with different parts of myself. I was able to reach parts of me where trauma was stored and work gently to heal these parts which had significant impacts on my overall wellbeing. It is with my strongest stamp of endorsement that I recommend Lauren for your hypnotherapy journeys. Lauren's kind and gentle awareness will guide you to deep aspects of yourself. She is extremely professional and highly skilled at her practice.`,
    name: 'Dr. Allan S.',
    practitionerName: 'Lauren Welchner',
    avatar: LaurenWelchner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.lilac,
  },
  {
    id: 52,
    text: `"Working with Lauren has given me some relief and hope that I haven't had in the 10+ years dealing with my chronic pain."`,
    boldText: `Right away, Lauren made me feel relaxed and comfortable with this process. I started working with Lauren right after a bad pain flare up with endometriosis. We've only had two sessions and I can already see the benefits of the work we did. My pain has truly lessened, and I cannot wait to work with her more. I whole-heartedly recommend Lauren. She has restored hope back into my life and helped me see a light at the end of the tunnel.`,
    name: 'Robin T.',
    practitionerName: 'Lauren Welchner',
    avatar: LaurenWelchner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.rose,
  },
  {
    id: 53,
    text: `"Working with Lauren was truly a game-changer for me."`,
    boldText: `I felt completely at ease and supported by her. She has an incredible way of making you feel seen and heard, and the shifts I experienced after working with her have been profound. Lauren helped me uncover things that I didn't even realize were holding me back, and I'm so grateful to have connected with her. If you are looking for someone who really listens and helps you transform, I can't recommend her enough!`,
    name: 'Christa G.',
    practitionerName: 'Lauren Welchner',
    avatar: LaurenWelchner,
    reviewAuthorAvatar: '',
    backgroundColor: avatarPlaceholderColors.teal,
  },
];

export const states = [
  { label: 'Alabama', value: 'Alabama' },
  { label: 'Alaska', value: 'Alaska' },
  { label: 'Arizona', value: 'Arizona' },
  { label: 'Arkansas', value: 'Arkansas' },
  { label: 'California', value: 'California' },
  { label: 'Colorado', value: 'Colorado' },
  { label: 'Connecticut', value: 'Connecticut' },
  { label: 'Delaware', value: 'Delaware' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Hawaii', value: 'Hawaii' },
  { label: 'Idaho', value: 'Idaho' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Indiana', value: 'Indiana' },
  { label: 'Iowa', value: 'Iowa' },
  { label: 'Kansas', value: 'Kansas' },
  { label: 'Kentucky', value: 'Kentucky' },
  { label: 'Louisiana', value: 'Louisiana' },
  { label: 'Maine', value: 'Maine' },
  { label: 'Maryland', value: 'Maryland' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'Michigan', value: 'Michigan' },
  { label: 'Minnesota', value: 'Minnesota' },
  { label: 'Mississippi', value: 'Mississippi' },
  { label: 'Missouri', value: 'Missouri' },
  { label: 'Montana', value: 'Montana' },
  { label: 'Nebraska', value: 'Nebraska' },
  { label: 'Nevada', value: 'Nevada' },
  { label: 'New Hampshire', value: 'New Hampshire' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New Mexico', value: 'New Mexico' },
  { label: 'New York', value: 'New York' },
  { label: 'North Carolina', value: 'North Carolina' },
  { label: 'North Dakota', value: 'North Dakota' },
  { label: 'Ohio', value: 'Ohio' },
  { label: 'Oklahoma', value: 'Oklahoma' },
  { label: 'Oregon', value: 'Oregon' },
  { label: 'Pennsylvania', value: 'Pennsylvania' },
  { label: 'Rhode Island', value: 'Rhode Island' },
  { label: 'South Carolina', value: 'South Carolina' },
  { label: 'South Dakota', value: 'South Dakota' },
  { label: 'Tennessee', value: 'Tennessee' },
  { label: 'Texas', value: 'Texas' },
  { label: 'Utah', value: 'Utah' },
  { label: 'Vermont', value: 'Vermont' },
  { label: 'Virginia', value: 'Virginia' },
  { label: 'Washington', value: 'Washington' },
  { label: 'West Virginia', value: 'West Virginia' },
  { label: 'Wisconsin', value: 'Wisconsin' },
  { label: 'Wyoming', value: 'Wyoming' },
];

export const languages = [
  { label: 'English', value: 'English' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Mandarin Chinese', value: 'Mandarin Chinese' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'French', value: 'French' },
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Bengali', value: 'Bengali' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'German', value: 'German' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Tagalog', value: 'Tagalog' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Other', value: 'Other' },
  { label: 'No preference', value: 'No preference' },
];

export const ageRanges = [
  {
    value: 'Under 14 (Child Hypnotherapy)',
    label: 'Under 14 (Child Hypnotherapy)',
  },
  { value: '14–17 (Teen Hypnotherapy)', label: '14–17 (Teen Hypnotherapy)' },
  { value: '18–25', label: '18–25' },
  { value: '26–40', label: '26–40' },
  { value: '41–60', label: '41–60' },
  { value: '61+', label: '61+' },
];

export const therapyOptions = [
  {
    id: 1,
    label: 'Hypnotherapy (Adults 18+)',
    subtext: 'Support for personal growth, behavior change, and relief from emotional challenges',
  },
  {
    id: 2,
    label: 'Teen Hypnotherapy (Ages 14–17)',
    subtext: 'Support for stress, self-esteem, academic performance, and emotional well-being',
  },
  {
    id: 3,
    label: 'Child Hypnotherapy (Under 14)',
    subtext: 'Safe, age-appropriate support for fears, habits, attention, and emotional balance',
  },
  {
    id: 4,
    label: 'Couples Hypnotherapy',
    subtext: 'Strengthen communication, resolve conflicts, and deepen connection',
  },
  {
    id: 5,
    label: 'Psychiatry Services',
    subtext:
      'Licensed psychiatric care for diagnosis, medication management, and integrative mental health',
  },
];

export const habbitsOptions = [
  {
    color: '#C7895E',
    text: 'Transform Relationships',
  },
  {
    color: '#7A72A6',
    text: 'Sleep Better',
  },
  {
    color: '#B07A8E',
    text: 'Restore Emotional Balance',
  },
  {
    color: '#6A8E8B',
    text: 'Reduce Stress',
  },
  {
    color: '#6E849D',
    text: 'Nurture Mental Wellness',
  },
  {
    color: '#9A7BA3',
    text: 'Transform Daily Patterns',
  },
  {
    color: '#5E8F93',
    text: 'Create Lasting Change',
  },
  {
    color: '#B8805A',
    text: 'Lose Weight',
  },
  {
    color: '#66829E',
    text: 'Stop Smoking',
  },
];

export const FINAL_CTA = {
  backgroundImage: section7Bg,
  title: 'Your Journey Starts Here.',
  subtitle: 'You’re one click away from meeting your hypnotherapist.',
  buttonText: 'Request a Free 30-Minute Consultation',
};
